import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Form } from 'core/forms';

import { Typo } from 'uikit/content';

import NewItemFormButtons from './newItemFormButtons';

import styles from '../styles/newItemForm.module.scss';

const NewItemForm = ({
  cancelText = '',
  hasError = false,
  isFullScreen = true,
  isSubmitDisabled = false,
  isSubmitting = false,
  model = {},
  onCancel = () => {},
  onLoad = () => {},
  onSubmit = () => {},
  onUpdate = () => {},
  schemas = [],
  hasCancelButton = true,
  submitColor = 'brand',
  submitText = '',
}) => (
  <>
    <div className={classnames(styles.element, isFullScreen && styles.isFullScreen)}>
      {schemas.map(({ schema, title }, index) => (
        <Fragment key={title ?? index}>
          {title && (
            <Typo className={styles.title} element="h2" variant="d01">
              {title}
            </Typo>
          )}
          <div className={styles.form}>
            <Form model={model} onLoad={onLoad} onUpdate={onUpdate} schema={schema} />
          </div>
        </Fragment>
      ))}
    </div>
    <NewItemFormButtons
      cancelText={cancelText}
      hasError={hasError}
      isFullScreen={isFullScreen}
      isSubmitting={isSubmitting}
      isSubmitDisabled={isSubmitDisabled}
      onCancel={onCancel}
      onSubmit={onSubmit}
      hasCancelButton={hasCancelButton}
      submitColor={submitColor}
      submitText={submitText}
    />
  </>
);

NewItemForm.propTypes = {
  cancelText: PropTypes.string,
  hasError: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  isSubmitDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  model: PropTypes.shape({}),
  onCancel: PropTypes.func,
  onLoad: PropTypes.func,
  onSubmit: PropTypes.func,
  onUpdate: PropTypes.func,
  hasCancelButton: PropTypes.bool,
  schemas: PropTypes.arrayOf(
    PropTypes.shape({ schema: PropTypes.shape({}), title: PropTypes.string }),
  ),
  submitColor: PropTypes.oneOf(['primary', 'secondary', 'brand', 'negative']),
  submitText: PropTypes.string,
};

export default React.memo(NewItemForm);
